export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/services', 'admin.service-buckets')
    .when('/admin/services/price/calculator', 'admin.service-price-calculator')
    .when('/admin/services/:id', 'admin.service-bucket-info')

    .within('admin')

    .segment('service-buckets', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.services'
      }],
      template: '<admin-service-buckets-list-page></admin-service-buckets-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-services-list.module" */ "./list/admin-services-list.module");
      }
    })

    .segment('service-price-calculator', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.services',
          url: '/admin/services'
        },
        {
          label: 'admin.breadcrumb.service_price_calculator',
        }
      ],
      template: '<admin-service-price-calculator-page></admin-service-price-calculator-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-price-calculator.module" */ "./price-calculator/admin-service-price-calculator.module");
      }
    })

    .segment('service-bucket-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.services',
          url: '/admin/services'
        },
        {
          label: 'admin.breadcrumb.service_bucket_info',
        }
      ],
      template: '<admin-service-bucket-info-page></admin-service-bucket-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-bucket-info.module" */ "./info/admin-service-bucket-info.module");
      }
    })
}
